import {
  AsideMenu,
  AsideMenuItemLinkType,
  BgColorType,
  SpacingType,
} from "@/lib/main";
import AsideNavLink from "./AsideNavLink";

type PropsType = {
  asideMenuItems: AsideMenuItemLinkType[];
  bgColor?: BgColorType;
  columnGap?: SpacingType;
  rowGap?: SpacingType;
};

export default function AsideNav({
  asideMenuItems,
  bgColor,
  columnGap,
  rowGap,
}: PropsType) {
  return (
    <AsideMenu columnGap={columnGap} rowGap={rowGap}>
      {asideMenuItems &&
        asideMenuItems.length > 0 &&
        asideMenuItems.map((item) => (
          <AsideNavLink key={item.id} bgColor={bgColor} item={item} />
        ))}
    </AsideMenu>
  );
}
